import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ModalItem from '../../common/ModalItem/ModalItem';
import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import './code.scss';
import OutlinedButton from '../../common/OutlinedButton';
import { useHistory, useLocation } from 'react-router';
import * as paymentActions from '../../../store/paymentSlice';
import * as uiActions from '../../../store/uiSlice';
import * as placesActions from '../../../store/placesSlice';
import CustomBackdrop from '../../common/CustomBackdrop';
import { completedRoutes, paymentStates } from '../../../common/constants';
import { get } from 'lodash';

function AdminPaymentCode(props) {
  const location = useLocation();
  const placeId = get(location, 'state.placeId', null);
  const {
    code, cancel, changeErrorPopupState, fetchingState, getPaymentById, paymentData,
    changeSuccessPopupState, getPlaceById,
  } = props;
  const { id: paymentId } = paymentData;
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    let checkPaymentStatusTimeout;
    const getPaymentPromise = (paymentId) => getPaymentById(paymentId)
      .then((payment) => {
        const { state, amount } = payment;
        if (state === paymentStates.created) {
          checkPaymentStatusTimeout = setTimeout(getPaymentPromise, 10000, paymentId);
        } else if (state === paymentStates.approved) {
          changeSuccessPopupState({ isOpen: true, data: { amount, placeId }, type: 'adminPayment' });
          getPlaceById(placeId);
        } else {
          changeErrorPopupState({ isOpen: true, error: {}, type: 'adminPayment', data: { amount, placeId } });
        }
      })
      .catch((error) => {
        if (error.status === 401) {
          history.replace(completedRoutes.signUp, { currentUrl: completedRoutes.adminPayment(placeId), placeId });
        } else {
          console.error(error);
          changeErrorPopupState({ isOpen: true, error, type: 'default' });
        }
      });

    checkPaymentStatusTimeout = setTimeout(getPaymentPromise, 10000, paymentId);

    return () => clearTimeout(checkPaymentStatusTimeout);
  }, [
    changeSuccessPopupState, changeErrorPopupState, paymentId,
    getPaymentById, placeId, getPlaceById, history,
  ]);

  if (placeId === null) return null;

  const handleCancel = () => {
    cancel(placeId, paymentId)
      .then((data) => {
        if (data.state === paymentStates.approved) {
          changeErrorPopupState({ isOpen: true, error: {}, type: 'cancel', data: { placeId } });
        } else {
          history.replace(completedRoutes.adminPlaceInfo(placeId), { placeId });
        }
      })
      .catch((error) => {
        changeErrorPopupState({ isOpen: true, error, type: 'cancelRequest' });
      });
  };
  const isLoading = fetchingState === 'requesting';

  return (
    <ModalItem withBackButton={false}>
      <>
        <Container className="code-cnt">
          <h2>{t('adminPayment.codeTitle')}</h2>
          <span className="code">
          {code}
        </span>
          <p className="p2">
            {t('adminPayment.p2')}
          </p>
          <OutlinedButton text={t('adminPayment.cancel')}
                          className="out-button"
                          onClick={handleCancel}
          />
        </Container>
        <CustomBackdrop open={isLoading} />
      </>
    </ModalItem>
  );
}

const mapStateToProps = (state) => {
  return {
    fetchingState: state.payments.fetchingState,
    code: state.payments.payment.code,
    paymentData: state.payments.payment,
  }
};

const actionCreators = {
  cancel: paymentActions.paymentCancel,
  getPaymentById: paymentActions.getPaymentById,
  changeErrorPopupState: uiActions.changeErrorPopupState,
  changeSuccessPopupState: uiActions.changeSuccessPopupState,
  getPlaceById: placesActions.getPlaceById,
};

export default connect(mapStateToProps, actionCreators)(AdminPaymentCode);
